import { lazy } from 'react';

export const BoqList = lazy(() => import('./boq/BoqList'));
export const DatasheetList = lazy(() => import('./datasheet/DatasheetList'));